import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';

import auth from './auth';
import common from './common';
import resource from './resource';
import policy from './policy';
import role from './role';
import user from './user';
import advertiser from './advertiser';
import store from './store';
import offer from './offer';
import banners from './banners';
import hubble from './hubble';
import category from './category';
import remoteConfig from './remoteConfig';
import customCategory from './customCategory';
import challenge from './challenge';
import PrimeOffer from './primeOffer';
import EliteOffer from './eliteOffer';
import PrimeOfferCallbacks from './primeOfferCallbacks';
import additionalCashback from './additionalCashback';
import userReport from './userReport';
import offlineSaleReports from './OfflineSaleReporting';
import sapphireOfferJobs from './SapphireOfferReporting';
import offlinePrimeOfferReports from './OfflinePrimeOfferReporting';
import offlineEliteOfferReports from './OfflineEliteOfferReporting';
import offlineShareOfferReports from './OfflineShareOfferReporting';
import offlineUserEliteOfferReports from './OfflineUserEliteOfferReporting';
import customBillerCategory from './PaymentDashboard/customBillerCategory';
import biller from './PaymentDashboard/biller';
import billerCategory from './PaymentDashboard/billerCategory';
import refund from './PaymentDashboard/refund';
import campaign from './campaign';
import cpatCampaign from './cpatCampaign';
import influencer from './influencer';
import ShareOffer from './shareOffer';
import transferApproval from './PaymentDashboard/transferApproval';
import eliteReporting from './eliteReporting';
import ticketCheck from './ticketCheck';
import ticketTemplate from './ticketTemplate';

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  auth,
  role,
  user,
  store,
  offer,
  banners,
  hubble,
  common,
  PrimeOfferCallbacks,
  policy,
  resource,
  category,
  advertiser,
  remoteConfig,
  customCategory,
  challenge,
  PrimeOffer,
  EliteOffer,
  additionalCashback,
  userReport,
  offlineSaleReports,
  sapphireOfferJobs,
  offlinePrimeOfferReports,
  offlineEliteOfferReports,
  offlineShareOfferReports,
  offlineUserEliteOfferReports,
  customBillerCategory,
  biller,
  billerCategory,
  refund,
  transferApproval,
  campaign,
  cpatCampaign,
  influencer,
  ShareOffer,
  eliteReporting,
  ticketCheck,
  ticketTemplate,
});

export default createRootReducer;
